import { Component, Input, OnInit } from '@angular/core';
import { WidgetComponent } from '@widgets/widgets';

@Component({
  selector: 'lms-subscription-activation',
  templateUrl: './subscription-activation.component.html',
  styleUrls: ['./subscription-activation.component.scss']
})
export class SubscriptionActivationComponent implements WidgetComponent, OnInit {
  @Input() public data: any;
  public activation: any;
  public chartData: any[];
  constructor() {}

  public ngOnInit(): void {
    this.activation = this.data?.activation;
    this.chartData = this.activation.activeUsers.map(({ month: label, activeUsers: value }) => ({
      label,
      value,
      percentage: Math.round((value / this.activation.totalSeats) * 100)
    }));
  }
}
